module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-6.webp?78820ad1";